module.exports = __webpack_public_path__ + "img/mgh-gotanda.ff2e9e97.jpg";